<template>
  <div class="news-his-nav">
    <div class="his-nav">
      <div class="nav-list" @click="linkPath(1)">
        2025 年度极客公园 “中国创新力量 50” 智能出行领域榜单
      </div>
      <div class="nav-list" @click="linkPath(2)">
        "技术研发+渠道拓展" 双轮深度合作——金轮集团战略合作
      </div>
      <div class="nav-list" @click="linkPath(3)">
        TASOW探所与佰客屋深度战略合作
      </div>
      <div class="nav-list" @click="linkPath(9)">
        线下车主活动多
      </div>
      <div class="nav-list" @click="linkPath(6)">
        大牌合作伙伴背书
      </div>
      <div class="nav-list" @click="linkPath(4)">
        TASOW探所北京官方旗舰店开业
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    linkPath(type) {
      location.href = `news_${type}.html`;
    }
  }
}
</script>

<style lang="less" scoped>
.news-his-nav {
  flex: 0 0 270px;
  // width: 200px;
  // border-radius: 10px;
  .his-nav {
    background: rgba(176, 176, 176, 0.15);
    padding: 30px 10px 6px 35px;
  }
  .nav-list {
    position: relative;
    font-size: 14px;
    line-height: 22px;
    color: #666;
    padding-bottom: 20px;
    cursor: pointer;
    &:hover {
      color: #000;
    }
    &:after {
      position: absolute;
      content: '';
      left: -18px;
      top: 6px;
      width: 7px;
      height: 7px;
      background: #333;
      border-radius: 50%;
    }
  }
}
</style>
